<!-- 材料管理列表 -->
<template>
    <div class="app-container">
        <!-- 搜索栏 -->
        <el-card shadow="hover" class="search-card" ref="filterForm">
            <el-form :inline="true" size="small" @keyup.enter.native="toFilter">
                <el-form-item label="材料名称">
                    <el-input v-model="filter.name" placeholder="请输入" clearable style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-radio-group v-model="filter.category">
                        <el-radio-button label="">全部</el-radio-button>
                        <el-radio-button label="设备费"></el-radio-button>
                        <el-radio-button label="施工费"></el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" @click="toFilter">查询</el-button>
                    <el-button icon="el-icon-plus" type="success" @click="addData" v-permision_tjtf="'add'">新增</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 表格 -->
        <el-card shadow="hover" class="table-card">
            <el-table :data="tableData" :border="true" stripe highlight-current-row :current-row-key="selectedRowKey"
                row-key="id" style="width: 100%;" height="calc(100vh - 280px)" @row-click="handleRowClick"
                v-loading="loading">
                <el-table-column label="序号" type="index" width="80" :align="tableColumnAlign"></el-table-column>
                <el-table-column prop="name" label="材料名称" min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="category" label="类型" width="110" :align="tableColumnAlign"></el-table-column>
                <el-table-column prop="spec" label="规格型号" width="200" :align="tableColumnAlign"></el-table-column>
                <el-table-column prop="unit" label="单位" width="130" :align="tableColumnAlign"></el-table-column>
                <el-table-column prop="price_sale" label="销售单价" width="140" :align="tableColumnAlign">
                    <template slot-scope="scope">¥{{ scope.row.price_sale }}</template>
                </el-table-column>
                <el-table-column prop="price_cb" label="成本单价" width="140" :align="tableColumnAlign">
                    <template slot-scope="scope">¥{{ scope.row.price_cb }}</template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间" width="170"
                    :align="tableColumnAlign"></el-table-column>
                <el-table-column label="操作" width="100" :align="tableColumnAlign" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="updateData(scope.row)" v-permision_tjtf="'edit'">修改</el-button>
                        <el-button type="text" size="small" @click="deleteData(scope.row)" v-permision_tjtf="'delete'">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="my-pagination">
                <el-pagination background layout="sizes,total,prev,pager,next,jumper" :total="pageParams.total"
                    :page-size="pageParams.limit" :page-sizes="[5, 10, 50, 100, 500, 1000]"
                    :current-page="pageParams.page" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"></el-pagination>
            </div>
        </el-card>

        <!-- 新增/修改 抽屉弹窗（从右到左） -->
        <el-drawer :title="drawerTitle" :visible.sync="drawerVisible" direction="rtl" :size="drawerSize"
            @closed="resetForm">
            <div class="drawer-body">
                <el-form :model="form" :rules="formRules" ref="materialForm" label-width="90px">
                    <el-form-item label="材料名称" prop="name">
                        <el-input v-model="form.name" placeholder="请输入材料名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="类型" prop="category">
                        <el-radio-group v-model="form.category">
                            <el-radio-button label="设备费"></el-radio-button>
                            <el-radio-button label="施工费"></el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="规格型号" prop="spec">
                        <el-input v-model="form.spec" placeholder="请输入规格型号" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="单位" prop="unit">
                        <el-input v-model="form.unit" placeholder="请输入单位" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="销售单价" prop="price_sale">
                        <el-input v-model.number="form.price_sale" type="number" placeholder="请输入销售单价"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="成本单价" prop="price_cb">
                        <el-input v-model.number="form.price_cb" type="number" placeholder="请输入成本单价"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm">保存</el-button>
                        <el-button @click="drawerVisible = false">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import { getScanMaterialListApi, addScanMaterialApi, updateScanMaterialApi, deleteScanMaterialApi } from "@/api/scan.js"
import { mapGetters } from "vuex"
export default {
    name: 'MaterialManage',
    mixins: [pageMixin],
    data() {
        return {
            selectedRowKey: null,
            tableColumnAlign: 'center',
            filter: {
                name: '',
                category: '',
            },
            loading: false,
            tableData: [],
            drawerVisible: false,
            drawerTitle: '新增材料',
            drawerSize: '60%',
            form: this.getDefaultForm(),
            formRules: {
                name: [{ required: true, message: '请输入材料名称', trigger: 'blur' }],
                category: [{ required: true, message: '请选择类型', trigger: 'change' }]
            }
        }
    },
    created() {
        this.getData()
    },
    methods: {
        getData() {

            this.loading = true
            getScanMaterialListApi({
                page: this.pageParams.page,
                pagesize: this.pageParams.limit,
                name: this.filter.name || null,
                Where: this.filter.category || null
            })
                .then((res) => {
                    const rawData = res.data || []
                    this.tableData = rawData
                    this.pageParams.total = res.total || 0
                })
                .catch(err => {
                    console.error('获取获取材料列表数据失败:', err)
                    this.$message.error('获取材料数据失败')
                })
                .finally(() => {
                    this.loading = false
                })
        },
        // 行点击
        handleRowClick(row) {
            this.selectedRowKey = row.ID
        },
        getDefaultForm() {
            return {
                name: '',
                category: '',
                spec: '',
                unit: '',
                price_sale: '',
                price_cb: ''
            }
        },
        // 新增
        addData() {
            this.drawerTitle = '新增材料'
            this.form = this.getDefaultForm()
            this.drawerVisible = true
        },
        // 修改：回显列表传递的数据
        updateData(row) {
            this.drawerTitle = '修改材料'
            this.form = {
                ID: row.ID,
                name: row.name,
                category: row.category,
                spec: row.spec,
                unit: row.unit,
                price_sale: row.price_sale,
                price_cb: row.price_cb
            }
            this.drawerVisible = true
        },
        // 删除
        deleteData(row) {
            this.$confirm(`确认删除材料「${row.name || ''}」吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                return deleteScanMaterialApi({ ID: row.ID })
            }).then(() => {
                this.$message.success('删除成功')
                this.getData()
            }).catch(() => {})
        },
        // 提交新增/修改
        submitForm() {
            this.$refs.materialForm.validate((valid) => {
                if (!valid) return
                const params = { ...this.form }
                const isEdit = !!params.ID
                const api = isEdit ? updateScanMaterialApi : addScanMaterialApi
                api(params).then(() => {
                    this.$message.success(isEdit ? '修改成功' : '新增成功')
                    this.drawerVisible = false
                    this.getData()
                }).catch(() => {})
            })
        },
        // 抽屉关闭后重置表单
        resetForm() {
            this.form = this.getDefaultForm()
            if (this.$refs.materialForm) {
                this.$refs.materialForm.clearValidate()
            }
        }
    }

}
</script>
<style scoped lang="scss">
.app-container {
    height: calc(100vh - 120px);
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    overflow: hidden;
    box-sizing: border-box;
}

.search-card {
    flex-shrink: 0;

    ::v-deep .el-card__body {
        padding: 12px 16px;
    }
}

.table-card {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;

    ::v-deep .el-card__body {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 12px;
        overflow: hidden;
    }
}

.my-pagination {
    margin-top: 20px;
    text-align: right;
    flex-shrink: 0;
}

.table-header-cell {
    background-color: #f5f7fa;
    color: #606266;
    font-weight: 600;
}

.drawer-body {
    padding: 8px 16px;

    ::v-deep .el-form-item {
        margin-bottom: 22px;
    }
}
</style>